<template>
    <div id="systemfunction">
        <HrrBreadcrumb PMname="用户权限管理" CMname="功能管理" />
        <HrrDetailLayout>
            <template slot="head">
                {{title}}
            </template>
            <template slot="Form">
                <el-form status-icon :model="functionform" ref="functionform" :rules="functionrules" label-width="120px" class="el-form-module" :hide-required-asterisk="isView">
                    <el-form-item label="功能名称：" prop="functionName">
                        <el-input v-model="functionform.functionName" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{functionform.functionName}}
                        </span>
                    </el-form-item>
                    <el-form-item label="功能描述：" prop="functionDesc">
                        <el-input v-model="functionform.functionDesc" v-if="isAdd||isEdit" type="textarea" :rows="3"></el-input>
                        <span v-if="isView">
                            {{functionform.functionDesc}}
                        </span>
                    </el-form-item>
                    <el-form-item label="功能代码：" prop="functionCode">
                        <el-input v-model="functionform.functionCode" v-if="isAdd||isEdit"></el-input>
                        <span v-if="isView">
                            {{functionform.functionCode}}
                        </span>
                    </el-form-item>
                    <el-form-item label="功能类型：" prop="functionType" >
                        <el-select v-model="functionform.functionType" placeholder="请选择功能类型" v-if="isAdd||isEdit" @change="funtypechange()">
                            <el-option label="通用" value="common"></el-option>
                            <el-option label="私有" value="private"></el-option>
                        </el-select>
                        <span v-if="isView">
                            {{functionform.Function_Type_str}}
                        </span>
                    </el-form-item>
                    <el-form-item label="专属模块名称：" v-if="functionform.functionType=='private'">
                        <el-select v-model="functionform.moduleId" placeholder="请选择模块" value-key="moduleId" :disabled="!(isAdd||isEdit)">
                            <el-option-group v-for="father in moduleData" :key="father.moduleId" :label="father.moduleName">
                                <el-option v-for="item in father.childMenuList" :key="item.moduleId" :label="item.moduleName" :value="item.moduleId">
                                </el-option>
                            </el-option-group>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态：">
                        <el-select v-model="functionform.status" placeholder="请选择状态" v-if="isAdd||isEdit">
                            <el-option label="启用" :value="1"></el-option>
                            <el-option label="禁用" :value="0"></el-option>
                        </el-select>
                        <span v-if="isView">
                            {{functionform.Status_str}}
                        </span>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button type="primary" @click="submitMForm('functionform')" v-if="isAdd||isEdit">提 交</el-button>
                <el-button @click="resetMForm('functionform')" v-if="isAdd||isEdit">重 置</el-button>
                <el-button type="info" @click="returnMForm()">返 回</el-button>
            </template>
        </HrrDetailLayout>
    </div>
</template>
<script>
export default {
    name: 'functiondetail',
    data() {
        return {
            functionform: {
                functionId: "",
                functionName: "",
                functionCode: "",
                functionType: "",
                functionURL: "",
                moduleId: "",
                functionDesc: "",
                status: "",
                Function_Type_str: "",
                Status_str: ""
            },
            functionrules: {
                functionName: [{ required: true, message: '请输入功能名称', trigger: 'blur' }],
                functionCode: [{ required: true, message: '请输入功能代码', trigger: 'blur' }],
                functionType: [{ required: true, message: '请输入功能类型', trigger: 'blur' }]
            },
            moduleData: [],
            title: "",
            isView: false,
            isEdit: false,
            isAdd: false,
        }
    },
    methods: {
        submitMForm: function(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    var loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var apiUrl = this.$api.system.function+(this.isAdd ? "" : "/" + this.functionform.functionId);
                    var m = this.isAdd ? "POST" : "PUT";
                    this.$hrraxios({
                            method: m,
                            url: apiUrl,
                            data: this.functionform
                        })
                        .then(function(response) {
                            loading.close();
                            var data = response.data;
                            if (data.Success == true) {
                                Vuethis.$alert("提交成功！", {
                                    callback: action => {
                                        Vuethis.$router.push({ path: '/system/function/' });
                                    }
                                });
                            } else {
                                Vuethis.$message({ message: data.Prompt, type: "error" });
                            }
                        }).catch(function(error) {
                            loading.close();
                            console.log(error);
                        })
                } else {
                    return false;
                }
            });
        },
        resetMForm: function(formName) {
            this.$refs[formName].resetFields();
        },
        returnMForm: function() {
            this.$router.go(-1);
        },
        funtypechange: function() {
            if (this.functionform.functionType == "common") {
                this.functionform.moduleId = "";
            }
        },
        //获取全部模块
        getModule() {
            var Vuethis = this;
            this.loading = true;
            this.$hrraxios.get(this.$api.system.moduleForDownList)
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.moduleData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
        },
        initData: function() {
            this.isView = false;
            this.isEdit = false;
            this.isAdd = false;
            var Hrrtype = this.$route.params.type; //类型
            var row = this.$route.meta.row;
            var info = "功能";
            if (Hrrtype != "add") {
                this.functionform = row;
                if (row.functionType == "common") {
                    this.functionform.Function_Type_str = "通用";
                } else {
                    this.functionform.Function_Type_str = "私有";
                }
                if (row.status == 1) {
                    this.functionform.Status_str = "正常";
                } else {
                    this.functionform.Status_str = "禁用";
                }
                this.$route.meta.row = null;

            }
            if (Hrrtype == "view") {
                this.title = "查看" + info;
                this.isView = true;
            }
            if (Hrrtype == "edit") {
                this.title = "编辑" + info;
                this.isEdit = true;

            }
            if (Hrrtype == "add") {
                this.title = "新增" + info;
                this.isAdd = true;
            }
        }
    },
    created: function() {
        this.$route.meta.row!=undefined?localStorage.setItem("row",JSON.stringify(this.$route.meta.row)):"";
        localStorage.getItem("row")!=undefined? this.$route.meta.row=JSON.parse(localStorage.getItem("row")):"";
        this.initData();
        this.getModule();
    }
}
</script>
<style>
.el-form-module {
    width: 500px;
}
</style>